import { Column, Copy, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { BudgetResetTypeSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect';
import { FrequencyPeriodSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/FrequencyPeriodSelect/FrequencyPeriodSelect';
import { BudgetResetCustomPeriodInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/TextInput/BudgetResetCustomPeriodInput/BudgetResetCustomPeriodInput';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';

export function FrequencyFields(): JSX.Element {
  const {
    isEditing,
    formValues: { isCustomLengthBudget, isRepeating },
  } = useMealCreditFormData();
  return (
    <Row gutter={8}>
      <Column phone={3} gutter={8}>
        <Stack y="x-sm">
          <FrequencyPeriodSelect
            name="budgetLength"
            id="budgetLength"
            disabled={isEditing}
          />
        </Stack>
      </Column>
      {isCustomLengthBudget && (
        <Column phone={9}>
          <Row gutter={8}>
            <Column
              desktop={isRepeating ? 3 : 1}
              phone={isRepeating ? 4 : 2}
              gutter={8}
            >
              <Stack y="sm">&nbsp;</Stack>
              <Copy variant="body" display="block" textAlign="center">
                {isRepeating ? 'Refreshes every' : 'For'}
              </Copy>
            </Column>
            <Column desktop={3} phone={4} gutter={8}>
              <BudgetResetCustomPeriodInput
                disabled={isEditing}
                name="budgetResetPeriod"
                id="budgetResetPeriod"
              />
            </Column>
            <Column desktop={3} phone={4} gutter={8}>
              <BudgetResetTypeSelect
                disabled={isEditing}
                id="budgetResetType"
                name="budgetResetType"
              />
            </Column>
          </Row>
        </Column>
      )}
    </Row>
  );
}
